import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../authContext';

const LoggedRoute = ({ children }) => {
  const { userLoggedIn} = useAuth();

  return userLoggedIn ? children : <Navigate to="/signin" replace />;
};

export default LoggedRoute;